<template>
    <div class="flex w-screen shrink-0 flex-col overflow-auto pb-lg pt-[100px] lg:w-[450px]">
        <slot></slot>
    </div>
</template>
